module.exports = __webpack_public_path__ + "img/download_icon.8874e06d.svg";